import { getDynamicPositionAttributes } from '~/modules/common/charts/timeline/calculations';
import { mapIsoStringtoUtcObject } from '~/modules/common/dates/convert';
import {
  getResizeDirection,
  decreaseMagnitude,
  calculateDeltaDates
} from '~/modules/resourcing/common/hooks/useGestureUtil';

export const getEstimatedResourceRequest = ({
  target,
  delta,
  down,
  project: { startDate, endDate },
  resourceRequest,
  chartStartDate,
  scale
}) => {
  const { dynamicPosition } = getDynamicPositionAttributes({
    chartStartDate,
    start: mapIsoStringtoUtcObject(resourceRequest.startDate),
    end: mapIsoStringtoUtcObject(resourceRequest.endDate),
    scale
  });

  const resizeDirection = getResizeDirection(target);
  const sizeDelta = delta[0];
  const loadingDelta = decreaseMagnitude(-delta[1] / 2, 20);
  const isActive = down && loadingDelta === 0;
  const estimatedResourceRequest = calculateDeltaDates({
    chartStartDate,
    scale,
    startDate: mapIsoStringtoUtcObject(resourceRequest.startDate),
    endDate: mapIsoStringtoUtcObject(resourceRequest.endDate),
    projectStartDate: mapIsoStringtoUtcObject(startDate),
    projectEndDate: mapIsoStringtoUtcObject(endDate),
    isActive,
    resizeDirection,
    sizeDelta
  });

  return {
    dynamicStyle: {
      ...dynamicPosition,
      ...(estimatedResourceRequest.moveDelta
        ? {
            transform: `translate3d(${estimatedResourceRequest.moveDelta}px,0px,0)`
          }
        : {}),
      ...(estimatedResourceRequest.sizeDelta
        ? {
            width: dynamicPosition.width + estimatedResourceRequest.sizeDelta
          }
        : {})
    },
    estimatedResourceRequest
  };
};

const useEstimatedResourceRequest = ({
  chartStartDate,
  delta,
  down,
  project,
  resourceRequest,
  scale,
  target
}) =>
  getEstimatedResourceRequest({
    chartStartDate,
    delta,
    down,
    project,
    resourceRequest,
    scale,
    target
  });

export default useEstimatedResourceRequest;
